import React, { useEffect, useRef, useState } from "react";

import { CHARTING_OPTION, CHART_OPTIONS, CHART_TABLE_OPTIONS, CLINICAL_SCORE_ACTIVE_DATE, getChartHeader, getData, getDownloadChartOption, getParameterList, PAGE_PARENT, SIDEBAR_ICON, VITAL_GRAPH_VIEW_PARAM, VITAL_VIEW_CONTANTS } from "../../common/constant/common-constants";

import clockSvg from "../../common/icons/svg/clock.svg";
import crossSvg from "../../common/icons/svg/cross.svg";
import downloadSvg from "../../common/icons/svg/download.svg";
import updatedInfoSvg from "../../common/icons/svg/updated-info-icon.svg"
// import down_arrow_svg from "../../common/icons/svg/down-arrow.svg";
import { useNavigate } from "react-router-dom";
import { redirect } from "../../common/utils/RedirectionUtils";

import "./ChartContainer.scss";
import DatePicker from "react-date-picker";
import { getChartData, updateChartData, getChartTimeline, downloadChart, autoFetchVitalTrends } from "../../helper/chart-helper";
import { ChartTable } from "../../components/Table/Chart/ChartTable";
import moment from "moment";
import { getDateForChart } from "../../common/utils/DateUtils";
import { selectedChartingOptionAction } from "../../modules/actions/action";
import { connect } from "react-redux";
import { CHART_CONST, PAGE_CONST, CLINICAL_SCORE } from "../../common/constant/page-constants";
import { VITAL_VIEW_MODES } from "../../common/constant/common-constants";
import DrugAdminstration from "../../components/Table/DrugAdministration/DrugAdministration";
import { IoBalance } from "../../components/Table/IoBalance/IoBalance";
import { ClinicalScores } from "../../components/Table/ClinicalScores/ClinicalScores";
import { domToReact } from "html-react-parser";
import { setCookieCustom } from "../../common/utils/StorageUItils";
import BundlesContainer from '../../components/Table/Bundles/BundlesContainer';
import LinesContainer from '../../components/Table/Lines/LinesContainer';
import { tab } from "@testing-library/user-event/dist/tab";
import CustomSelect from "../../components/CustomSelect/CustomSelect";
import ApexChart from "../../components/Chart/ApexChart";
import VitalApexChart from "../../components/VitalApexChart/VitalApexChart";

function ChartContainer(props) {
    const navigate = useNavigate();
    const [activeOption, setActiveOption] = useState((props.chartingOptionActive === CHARTING_OPTION.CLINICAL_SCORES) ?
        CHARTING_OPTION.CLINICAL_SCORES : CHART_OPTIONS.VITALS);
    const [tableData, setTableData] = useState({});
    const [prescriptionDate, setPrescriptionDate] = useState(getDateForChart());
    const [headerList, setHeaderList] = useState(getChartHeader(activeOption));
    const [parameterList, setParameterList] = useState(getParameterList(activeOption));
    const [isEditable, setIsEditable] = useState(false);
    const [prescriptionData, setPrescriptionData] = useState([]);
    const [timelineData, setTimelineData] = useState([]);
    const [ioData, setIoData] = useState({})
    const [clinicalScore, setClinicalScore] = useState({});
    const [clinicalScoreModal, setClinicalScoreModal] = useState(false);
    const [updateInfo, setUpdateInfo] = useState(false);
    const [confirmSubmitModal, setConfirmSubmitModal] = useState(false);
    const [downloadFileURL, setDownloadFileURL] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [updateBundlesData, setUpdateBundlesData] = useState(false);
    const [submitLines, setSubmitLines] = useState(false);
    const [cumulativeBal, setCumulativeBal] = useState(0);
    const [fetchDataWaitText, setFetchDataWaitText] = useState("");
    const [netIOBalance, setNetIOBalance] = useState("");
    const [downloadFileName, setDownloadFileName] = useState("");
    const [vitalView, setVitaView] = useState(VITAL_VIEW_CONTANTS.NUMERIC_DATA);
    // const [vitalGraphTime, setVitalGraphTime] = useState(VITAL_VIEW_CONTANTS.LAST_24_HOURS);
    const [vitalGraphData, setVitalGraphData] = useState([]);
    const [vitalGraphDataTime, setVitalGraphDataTime] = useState([]);
    const [vitalGraphCheckedParam, setVitalGraphCheckedParam] = useState(['hr']);
    const refDownload = useRef(null);

    useEffect(() => {
        getChartDataHandler(activeOption);
        chartTimelineHandler();
        if (props.activeSidebarIcon === SIDEBAR_ICON.PATIENT_BOOK) setPrescriptionDate(new Date(props.patientAdmissionDate));
    }, []);

    useEffect(() => {
        getChartDataHandler(activeOption);
        chartTimelineHandler();
    }, [prescriptionDate])

    useEffect(() => {
        vitalsGraphDataStructuring(tableData.data);
    }, [vitalGraphCheckedParam.length])

    const handleOptionClick = (option) => {
        setActiveOption(option);
        getChartDataHandler(option);
    }

    const handleDataChange = (id, header, key, value) => {
        // console.log("type", header, "id", id, "key", key, "event", value)
        // console.log("tableData in chartContainer", tableData.data);
        let dataList = tableData.data;

        const col = dataList.filter((obj) => obj.id === id)[0];

        // console.log("col", col);
        value = (value === "") ? null : value;
        if (col) {
            col[key] = value;
        } else {
            let change = {
                [key]: value
            }
            let tempData = {
                "id": id,
                "time": header,
                "isUpdated": false,
            }
            parameterList.map((param) => {
                tempData[param.name] = null
            })

            if (activeOption === CHART_OPTIONS.NURSING_CHECKS || CHART_OPTIONS.BUNDLES) tempData["shift"] = header;
            else tempData["time"] = header;

            tempData = {
                ...tempData,
                ...change
            }

            dataList.push(tempData);
        }

        setTableData({ ...tableData });
        // console.log("tableData", tableData)
    }

    const handleDownloadClick = () => {
        if (!downloadFileURL) {
            setIsLoading(true);
        }

        let data = {
            chartType: getDownloadChartOption(activeOption),
            bedId: props.bedId,
            patientSessionId: props.patientSessionId,
            date: moment(prescriptionDate).format("YYYY-MM-DD"),
            hospitalName: props.hospitalName,
            selectedWard: props.selectedWard,
        }
        startDownload(data);
    }

    const startDownload = (data) => {
        try {
            downloadChart(data).then((res) => {
                // setDownloadFileName('filename');
                setDownloadFileURL(res.url);
            }).catch((err) => {
                alert("Download failed!!!");
                setIsLoading(false);
            });

        } catch (error) {
            alert("Download failed!!!");
            setIsLoading(false);
        }
    }

    useEffect(() => {
        refDownload.current?.click();
        setIsLoading(false);
    }, [downloadFileURL])

    useEffect(() => {
        setDownloadFileURL('');
        setIsLoading(false);
    }, [prescriptionDate, activeOption])

    useEffect(() => {
        if (activeOption === CHARTING_OPTION.CLINICAL_SCORES) {
            props.selectedChartingOptionAction(CHARTING_OPTION.CLINICAL_SCORES);
        } else {
            props.selectedChartingOptionAction(CHARTING_OPTION.OTHER);
        }
    }, [activeOption])

    // useEffect(() => {
    //     let data = {
    //         chartType: CHART_OPTIONS.VITALS,
    //         bedId: props.bedId,
    //         patientSessionId: props.patientSessionId,
    //         date: moment(prescriptionDate).format("YYYY-MM-DD")
    //     }

    //     if (vitalGraphTime === VITAL_VIEW_CONTANTS.TODAY) {
    //         getChartData(data).then((res) => {
    //             // console.log("res for vital graph", res);
    //             // setTableData({ ...res });
    //             vitalsGraphDataStructuring(res && res.data);
    //         }).catch((err) => {
    //             console.log("error occured in fetching chart data");
    //         });

    //     } else if (vitalGraphTime === VITAL_VIEW_CONTANTS.LAST_24_HOURS) {
    //         data.date = moment(prescriptionDate).subtract(24, 'hours').format("YYYY-MM-DD");
    //         console.log("date and time", moment(prescriptionDate).subtract(24, 'hours'))
    //         // .format("YYYY-MM-DD"))
    //         getChartData(data).then((res) => {
    //             // console.log("res for vital graph", res);
    //             // setTableData({ ...res });
    //             // console.log("yesterday date", moment(prescriptionDate).subtract(1, 'days'));
    //             // data.date = moment(prescriptionDate).subtract(1, 'days').format("YYYY-MM-DD");
    //             vitalsGraphDataStructuring(res && res.data);
    //         }).catch((err) => {
    //             console.log("error occured in fetching chart data");
    //         });

    //     }
    // }, [vitalGraphTime])

    const vitalsGraphDataStructuring = (dataArr) => {
        if (dataArr) {
            let bpDObj = { name: VITAL_GRAPH_VIEW_PARAM.nibpD, data: [], color: '#FFFFFF' };
            let bpMeanObj = { name: VITAL_GRAPH_VIEW_PARAM.nibpM, data: [], color: '#FFFFFF' };
            let bpSObj = { name: VITAL_GRAPH_VIEW_PARAM.nibpS, data: [], color: '#FFFFFF' };
            let hrObj = { name: VITAL_GRAPH_VIEW_PARAM.hr, data: [], color: '#299842' };
            let pulseRateObj = { name: VITAL_GRAPH_VIEW_PARAM.pr, data: [], color: '#3ADAE5' };
            let rrObj = { name: VITAL_GRAPH_VIEW_PARAM.rr, data: [], color: '#FCC331' };
            let spo2Obj = { name: VITAL_GRAPH_VIEW_PARAM.spo2, data: [], color: '#3ADAE5' };
            let tempObj = { name: VITAL_GRAPH_VIEW_PARAM.temp, data: [], color: '#999999' };
            let timeArr = [];

            for (const vitals of dataArr) {
                timeArr.push(vitals.time);
                bpDObj.data.push(vitals.bpD)
                bpMeanObj.data.push(vitals.bpMean)
                bpSObj.data.push(vitals.bpS)
                hrObj.data.push(vitals.hr)
                pulseRateObj.data.push(vitals.pulseRate)
                rrObj.data.push(vitals.rr)
                spo2Obj.data.push(vitals.spo2)
                tempObj.data.push(vitals.temp)
            }

            let graphData = [];
            if (vitalGraphCheckedParam.findIndex((ele) => ele === 'nibpD') !== -1)
                graphData.push(bpDObj);
            if (vitalGraphCheckedParam.findIndex((ele) => ele === 'nibpS') !== -1)
                graphData.push(bpSObj);
            if (vitalGraphCheckedParam.findIndex((ele) => ele === 'nibpM') !== -1)
                graphData.push(bpMeanObj);
            if (vitalGraphCheckedParam.findIndex((ele) => ele === 'hr') !== -1)
                graphData.push(hrObj);
            if (vitalGraphCheckedParam.findIndex((ele) => ele === 'pr') !== -1)
                graphData.push(pulseRateObj);
            if (vitalGraphCheckedParam.findIndex((ele) => ele === 'rr') !== -1)
                graphData.push(rrObj);
            if (vitalGraphCheckedParam.findIndex((ele) => ele === 'spo2') !== -1)
                graphData.push(spo2Obj);
            if (vitalGraphCheckedParam.findIndex((ele) => ele === 'temp') !== -1)
                graphData.push(tempObj);

            setVitalGraphData(graphData);
            setVitalGraphDataTime(timeArr);
        }
    }

    const getChartingOptionHeading = () => {

        const html = Object.keys(CHART_OPTIONS).map(key =>

            <div
                className={activeOption === CHART_OPTIONS[key] ?
                    "charting-option selected-chart-option" : "charting-option"}
                onClick={() => {
                    handleOptionClick(CHART_OPTIONS[key])

                }}
                key={key}
            >
                {CHART_OPTIONS[key]}
            </div>
        )
        return html;
    }

    const getChartDataHandler = (chartType) => {

        let hl = getChartHeader(chartType)
        setHeaderList([...hl]);

        let pl = getParameterList(chartType);
        setParameterList([...pl]);

        if (!prescriptionDate) return;
        let data = {
            chartType: chartType,
            bedId: props.bedId,
            patientSessionId: props.patientSessionId,
            date: moment(prescriptionDate).format("YYYY-MM-DD")
        }

        getChartData(data).then((res) => {
            if (chartType === CHART_OPTIONS.DRUG_ADMINISTRATION) setPrescriptionData([...res]);
            else if (chartType === CHART_OPTIONS.I_O_BAL) {
                setIoData({ ...res.data });
                setCumulativeBal(res.cumulativeBalance)
            }
            else if (chartType === CHART_OPTIONS.CLINICAL_SCORES) setClinicalScore(res)
            else {
                setTableData({ ...res })
                vitalsGraphDataStructuring(res.data);
            }
        }).catch((err) => {
            console.log("error occured in fetching chart data");
        });
    }

    const chartTimelineHandler = () => {

        let data = {
            date: moment(prescriptionDate).format("YYYY-MM-DD"),
            bedId: props.bedId,
            patientSessionId: props.patientSessionId
        }

        getChartTimeline(data)
            .then((res) => {
                // console.log("timeline data", res.timeline) /
                if (res.timeline) setTimelineData(res.timeline);
            })
            .catch((err) => {
                console.log("timeline error :: " + err);
            })
    }

    const handleConfirmSubmitClick = () => {
        console.log("on submit --->")
        console.log("chart submit button clicked !!!!! ");
        setIsEditable(false);

        let data = {
            chartType: activeOption,
            bedId: props.bedId,
            patientSessionId: props.patientSessionId,
            date: moment(prescriptionDate).format("YYYY-MM-DD"),
            data: tableData.data
        }
        // removing id from the new data
        if (activeOption === CHART_OPTIONS.DRUG_ADMINISTRATION) {
            prescriptionData.map((prescription) => {
                let drugAdministrations = prescription.drugAdministrations;

                drugAdministrations.map((administration) => {

                    if (administration.id && (administration.id.toString().indexOf(CHART_CONST.NEW_ID_PRED) > -1)) {
                        administration.id = null
                    }
                })
            })

            data.data = prescriptionData;
        } else if (activeOption === CHART_OPTIONS.I_O_BAL) {
            data = {
                chartType: activeOption,
                bedId: props.bedId,
                patientSessionId: props.patientSessionId,
                date: moment(prescriptionDate).format("YYYY-MM-DD"),
                data: ioData,
                netBalance: netIOBalance,
                cumulativeBalance: (parseInt(netIOBalance) + parseInt(cumulativeBal)),
            }
        } else if (activeOption === CHART_OPTIONS.CLINICAL_SCORES) {
            data = {
                chartType: activeOption,
                bedId: props.bedId,
                patientSessionId: props.patientSessionId,
                date: moment(prescriptionDate).format("YYYY-MM-DD"),
                data: clinicalScore
            }
        } else if (activeOption === CHART_OPTIONS.BUNDLES) {
            setUpdateBundlesData(true);
        } else if (activeOption === CHART_OPTIONS.LINES) {
            setSubmitLines(true);
        } else {
            data.data && data.data.map((col) => {
                if (col.id && col.id.toString().indexOf(CHART_CONST.NEW_ID_PRED) > -1) {
                    col.id = null;
                }
            });
        }

        console.log('data for update', data);
        updateChartData(data).then((res) => {

            console.log(" updated data from api", res);
            // if (activeOption === CHART_OPTIONS.DRUG_ADMINISTRATION) setPrescriptionData(res);

            setTableData({ ...res });

            getChartDataHandler(activeOption);
            chartTimelineHandler();
        }).catch((err) => {
            console.log(err);
        });
        setConfirmSubmitModal(false)
    }

    const handleCancelClick = () => {

        getChartDataHandler(activeOption);
        setIsEditable(false);
    }

    const handleDateChange = (date) => {

        let nd = moment(date);
        setPrescriptionDate(date);
    }

    const handleChangeData = (data) => {

        setPrescriptionData([...data]);
    }

    const updateIoData = (data) => {

        setIoData({ ...data });
    }

    const handleIOSubmit = () => {

        // console.log(ioData);
    }

    const handleClinicalScoreCalculate = () => {
        setClinicalScoreModal(!clinicalScoreModal);
    }

    const handleClinicalScoreOption = (option) => {
        const data = {
            bedId: props.bedId,
        }
        setCookieCustom(CLINICAL_SCORE_ACTIVE_DATE, moment(prescriptionDate).format("YYYY-MM-DD"))
        redirect(navigate, option, data);
    }
    const handleUpdateModal = () => {
        setUpdateInfo(!updateInfo);
    }

    const handleDataFetchClick = () => {
        setFetchDataWaitText("Please wait while the data is being fetched...");
        let currTime = moment(new Date()).format("HH");
        let presDateIsBeforePresentDate = 0;
        if (moment(moment(prescriptionDate).format("YYYY-MM-DD")).isBefore(moment(new Date()).format("YYYY-MM-DD"))) presDateIsBeforePresentDate = 1;
        let tableDataTimeArr = tableData && tableData.data && tableData.data.map((ele) => ele.time.length === 4 ? ('0' + ele.time.slice(0, 1)) : ele.time.slice(0, 2));

        let timeArr = getChartHeader(CHART_OPTIONS.VITALS).splice(1).map((ele) => ele.slice(0, 2));
        let fetchingTimeArr;

        for (let tableTime of tableDataTimeArr) {
            timeArr.splice(timeArr.indexOf(tableTime), 1);
        }
        // fetchingTimeArr is the array which contains the time for which the 
        // column data is empty and is before currTime (current time)

        if (currTime <= "24" && (!presDateIsBeforePresentDate)) {
            fetchingTimeArr = timeArr.filter((ele) => ele >= "08" && ele <= currTime);
        } else {
            fetchingTimeArr = timeArr.filter((ele) => (ele >= "08" && ele <= "24") || (ele <= currTime));
        }
        fetchingTimeArr = fetchingTimeArr.map((time) => time + ':00');
        let data = {
            bedId: props.bedId,
            patientSessionId: props.patientSessionId,
            date: moment(prescriptionDate).format("YYYY-MM-DD"),
            timeList: fetchingTimeArr,
        }
        autoFetchVitalTrends(data).then((res) => {
            console.log("res from fetched data", res);
            setTableData(res);
            let fetchTimeout = setTimeout(() => (res.data.length > 0 ? setFetchDataWaitText("Data fetch complete!") : setFetchDataWaitText("Data fetch complete, no data for this date!")), 3000)
            return () => {
                clearTimeout(fetchTimeout);
            };
        }).catch((err) => {
            console.log("error in fetching", err);

        })
    }

    useEffect(() => {
        if (fetchDataWaitText) {
            let fetchTimeout = setTimeout(() => setFetchDataWaitText(""), 3000)
            return () => {
                clearTimeout(fetchTimeout);
            };
        }
    }, [fetchDataWaitText])

    const handleVitalView = (view) => {
        setVitaView(view.label);
    }

    const handleVitalCheckboxClick = (event) => {
        const vitalId = event.target.id;
        console.log("event", event.target.id, event.target.checked)
        if (event.target.checked) {
            setVitalGraphCheckedParam((prevState) => [
                ...prevState,
                vitalId
            ])
        } else {
            setVitalGraphCheckedParam((prevState) => prevState.filter((ele) => ele !== vitalId));
        }
    }
    // const handleVitalTimeClick = (item) => {
    //     setVitalGraphTime(item);
    // }

    return (
        <div className="chart-container">
            {props.parent === PAGE_PARENT.PATIENT_MODAL && <div className="chart-header-container">
                <div className="charting-text">Charting</div>
                <div className="chart-download-date-container">
                    {/* <div className="download-container">
                        <img src={downloadSvg} alt="download icon" className="download-icon" />
                        <div className="download-text"> Download</div>
                    </div> */}
                    <div className="date-container">
                        {/* <div className="date-text">Date: </div> */}
                        <DatePicker
                            className="charting-date"
                            onChange={(pd) => handleDateChange(pd)}
                            value={prescriptionDate}
                            clearIcon={null}
                            openCalendarOnFocus={true}
                            format="dd-MM-yyyy"
                            showLeadingZeros={false}
                        />
                    </div>
                </div>
            </div>}
            <div className="charting-option-download-container">
                <div className="charting-option-container">
                    {
                        getChartingOptionHeading()
                    }
                </div>
                {props.parent === PAGE_PARENT.BED_DETAIL && <div className="chart-option-download-date-container">
                    {downloadFileURL && <a href={downloadFileURL} className='hidden' download={downloadFileName} ref={refDownload} />}
                    {(vitalView === VITAL_VIEW_CONTANTS.NUMERIC_DATA || activeOption !== CHART_OPTIONS.VITALS) && (isLoading ?
                        <div className="spinner"></div> :
                        <div className="download-container" onClick={() => handleDownloadClick()}>
                            <img src={downloadSvg} alt="download icon" className="download-icon" />

                            <div className="download-text"> Download</div>
                        </div>)}
                    {props.activeSidebarIcon === SIDEBAR_ICON.HOME_PAGE && <div className="button-container">
                        {(vitalView === VITAL_VIEW_CONTANTS.NUMERIC_DATA || activeOption !== CHART_OPTIONS.VITALS) ? (isEditable ?
                            (
                                <>
                                    <div className="chart-cancel chart-button" onClick={() => handleCancelClick()}>
                                        Cancel
                                    </div>
                                    <div className="chart-submit chart-button" onClick={() => setConfirmSubmitModal(!confirmSubmitModal)}>
                                        Submit
                                    </div>
                                </>
                            )
                            : (<>
                                {activeOption !== CHART_OPTIONS.CLINICAL_SCORES &&
                                    <div className="chart-edit chart-button" onClick={() => setIsEditable(true)}>
                                        Edit
                                    </div>

                                }

                                {activeOption === CHART_OPTIONS.CLINICAL_SCORES &&
                                    <div className="chart-edit chart-button" onClick={handleClinicalScoreCalculate}>
                                        Calculate
                                    </div>
                                }

                            </>)) : (
                            ""
                        )
                        }
                        {confirmSubmitModal &&
                            <div className="confirm-submit-container">
                                <span className="save-heading">Save ?</span>
                                <span className="confirm-text">Are you sure you want to save the entered values?</span>
                                <div className="confirm-modal-btn">
                                    <div className="common-confirm-btn" onClick={() => setConfirmSubmitModal(false)}>Cancel</div>
                                    <div className="common-confirm-btn active-confirm-btn" onClick={() => handleConfirmSubmitClick()}>Confirm</div>
                                </div>
                            </div>
                        }
                    </div>}
                    {(vitalView === VITAL_VIEW_CONTANTS.NUMERIC_DATA || activeOption !== CHART_OPTIONS.VITALS) && (props.activeSidebarIcon === SIDEBAR_ICON.HOME_PAGE && <div className="updated-info-container">
                        <img className="updated-info-icon" src={updatedInfoSvg} onClick={handleUpdateModal} />
                    </div>)}
                    {vitalView === VITAL_VIEW_CONTANTS.NUMERIC_DATA && (updateInfo &&
                        <div className="last-updated-modal-container">
                            <span className="update-modal-heading">Update</span>
                            <div className="update-modal-text">
                                <div className="last-timeline">
                                    {timelineData[0] && `Last Updated by ${timelineData[0].userRole}: 
                                    ${timelineData[0].userName} (${timelineData[0].userId}) at 
                                    ${moment(timelineData[0].dateOfCharting).format("HH:mm")}`}
                                    {!timelineData[0] && "No updates yet!"}
                                </div>
                            </div>
                        </div>)
                    }
                </div>}
                {
                    clinicalScoreModal &&
                    <div className="clinical-modal-container">
                        <div className="clinical-modal-options">
                            <div className="common-clinical-cls default-select" onClick={() => handleClinicalScoreOption(CLINICAL_SCORE.GCS_SCORE)}>GCS</div>
                            <div className="common-clinical-cls" onClick={() => handleClinicalScoreOption(CLINICAL_SCORE.SOFA_SCORE)}>SOFA</div>
                            <div className="common-clinical-cls" onClick={() => handleClinicalScoreOption(CLINICAL_SCORE.BRADEN_SCORE)}>BRADEN</div>
                            <div className="common-clinical-cls" onClick={() => handleClinicalScoreOption(CLINICAL_SCORE.RASS_SCORE)}>RASS</div>
                            <div className="common-clinical-cls" onClick={() => handleClinicalScoreOption(CLINICAL_SCORE.FALL_RISK)}>RISK FALL</div>
                            <div className="common-clinical-cls" onClick={() => handleClinicalScoreOption(CLINICAL_SCORE.APACHE_2_SCORE)}>APACHE II</div>
                        </div>
                    </div>
                }
            </div>
            <div className={`chart-view-date-container ${activeOption === CHART_OPTIONS.I_O_BAL ? 'justify-right' : ''}
            ${activeOption === CHART_OPTIONS.VITALS ? "justify-space-between" : ""}
            `}>
                {activeOption === CHART_OPTIONS.VITALS && <div className="vital-view-container">
                    <div className="input-label">View</div>
                    <div className="view-select">
                        <CustomSelect
                            className="view-mode-select"
                            handleChange={(view) => handleVitalView(view)}
                            value={VITAL_VIEW_MODES.filter((ele) => ele.label === vitalView)}
                            label='PARAMETER NAME'
                            options={VITAL_VIEW_MODES}
                            isClearable={false}
                            components={{
                                IndicatorSeparator: () => null
                            }}
                            backgroundColor='#292929'
                        />
                    </div>
                </div>}

                {activeOption === CHART_OPTIONS.I_O_BAL &&
                    <div className="cumulative-bal">
                        Cumulative Balance: <span>{cumulativeBal}</span>
                    </div>}
                {/* {(vitalView === VITAL_VIEW_CONTANTS.NUMERIC_DATA || activeOption !== CHART_OPTIONS.VITALS) ? */}
                <div className="fetch-and-date-container">
                    {isEditable && activeOption === CHART_OPTIONS.VITALS && <div className="data-fetch-btn" onClick={handleDataFetchClick}>
                        Fetch Data
                    </div>}
                    <DatePicker
                        format="dd-MM-yyyy"
                        className={`charting-date`}
                        clearIcon={null}
                        closeCalendar={false}
                        showLeadingZeros={false}
                        onChange={(pd) => handleDateChange(pd)}
                        value={prescriptionDate}
                        maxDate={props.activeSidebarIcon === SIDEBAR_ICON.PATIENT_BOOK ? new Date(props.patientDischargeDate) : null}
                        minDate={props.activeSidebarIcon === SIDEBAR_ICON.PATIENT_BOOK ? new Date(props.patientAdmissionDate) : null}
                    />
                </div>
                {/* :
                    <div className="vital-graph-time-container">
                        <div className={`common-vital-view-btn ${vitalGraphTime === VITAL_VIEW_CONTANTS.TODAY ? "active-time-vital-view" : ""}`} onClick={() => handleVitalTimeClick(VITAL_VIEW_CONTANTS.TODAY)}>Today</div>
                        <div className={`common-vital-view-btn ${vitalGraphTime === VITAL_VIEW_CONTANTS.LAST_24_HOURS ? "active-time-vital-view" : ""}`} onClick={() => handleVitalTimeClick(VITAL_VIEW_CONTANTS.LAST_24_HOURS)}>Last 24 Hrs</div>
                        <div className={`common-vital-view-btn ${vitalGraphTime === VITAL_VIEW_CONTANTS.CUMMULATIVE ? "active-time-vital-view" : ""}`} onClick={() => handleVitalTimeClick(VITAL_VIEW_CONTANTS.CUMMULATIVE)}>Cumulative</div>
                    </div> */}
                {/* } */}

            </div>
            <div className="chart-data-container">
                <div className="chart-vital-container">
                    <div className={` ${activeOption !== CHART_OPTIONS.LINES ? 'data-table-container' : "lines-css"}`}>
                        {CHART_TABLE_OPTIONS.includes(activeOption) && tableData &&
                            <ChartTable
                                headerList={headerList}
                                parameterList={parameterList}
                                isEditable={isEditable}
                                data={tableData}
                                chartType={activeOption}
                                handleDataChange={(id, header, key, value) => handleDataChange(id, header, key, value)}
                            />
                        }
                        {(activeOption === CHART_OPTIONS.VITALS) ?
                            vitalView === VITAL_VIEW_CONTANTS.NUMERIC_DATA && tableData ?
                                <ChartTable
                                    headerList={headerList}
                                    parameterList={parameterList}
                                    isEditable={isEditable}
                                    data={tableData}
                                    chartType={activeOption}
                                    handleDataChange={(id, header, key, value) => handleDataChange(id, header, key, value)}
                                /> :
                                <div className="chart-vital-main">
                                    <div className="checkbox-container">
                                        <div><input type='checkbox' id='nibpD' onClick={(event) => handleVitalCheckboxClick(event)} /><label htmlFor="nibpD">NIBP(D)</label></div>
                                        <div><input type='checkbox' id='nibpM' onClick={(event) => handleVitalCheckboxClick(event)} /> <label htmlFor="nibpM">NIBP(M)</label></div>
                                        <div><input type='checkbox' id='nibpS' onClick={(event) => handleVitalCheckboxClick(event)} /> <label htmlFor="nibpS">NIBP(S)</label></div>
                                        <div><input type='checkbox' id='hr' onClick={(event) => handleVitalCheckboxClick(event)} defaultChecked={true} /> <label htmlFor="hr">HR</label></div>
                                        <div><input type='checkbox' id='rr' onClick={(event) => handleVitalCheckboxClick(event)} /> <label htmlFor="rr">RR</label></div>
                                        <div><input type='checkbox' id='pr' onClick={(event) => handleVitalCheckboxClick(event)} /> <label htmlFor="pr">PR</label></div>
                                        <div><input type='checkbox' id='spo2' onClick={(event) => handleVitalCheckboxClick(event)} /> <label htmlFor="spo2">SpO₂</label></div>
                                        <div><input type='checkbox' id='temp' onClick={(event) => handleVitalCheckboxClick(event)} /> <label htmlFor="temp">TEMP</label></div>
                                    </div>
                                    <div className="vital-chart">
                                        <VitalApexChart
                                            className="vital-chart"
                                            dataList={vitalGraphData}
                                            timeData={vitalGraphDataTime}
                                        // yMin={0}
                                        // yMax={80}
                                        // yTickPoint={4}
                                        // width={"100%"}
                                        />
                                    </div>
                                </div> : ""
                        }
                        {activeOption === CHART_OPTIONS.DRUG_ADMINISTRATION &&
                            <DrugAdminstration
                                // headerList={headerList}
                                data={prescriptionData}
                                isEditable={isEditable}
                                handleChangeData={(data) => handleChangeData(data)}
                            />}
                        {activeOption === CHART_OPTIONS.I_O_BAL &&
                            <IoBalance
                                isEditable={isEditable}
                                data={ioData}
                                updateData={(data) => updateIoData(data)}
                                // prevDateIOData={prevDateIOData}
                                cumulativeBal={cumulativeBal}
                                setNetIOBalance={setNetIOBalance}
                            />
                        }
                        {activeOption === CHART_OPTIONS.CLINICAL_SCORES &&
                            <ClinicalScores
                                headerList={headerList}
                                parameterList={parameterList}
                                data={clinicalScore}
                            />
                        }
                        {activeOption === CHART_OPTIONS.BUNDLES &&
                            <BundlesContainer
                                headerList={headerList}
                                parameterList={parameterList}
                                setUpdateBundlesData={setUpdateBundlesData}
                                updateBundlesData={updateBundlesData}
                                isEditable={isEditable}
                                data={{ bedId: props.bedId, patientSessionId: props.patientSessionId, prescriptionDate: prescriptionDate, }}
                            />
                        }
                        {activeOption === CHART_OPTIONS.LINES &&
                            <LinesContainer
                                setSubmitLines={setSubmitLines}
                                submitLines={submitLines}
                                isEditable={isEditable}
                                data={{ bedId: props.bedId, patientSessionId: props.patientSessionId, prescriptionDate: prescriptionDate, }}

                            />
                        }
                    </div>
                    {/* <div className="footer-container">
                        <div className="timeline-container">
                            {timelineData && timelineData.length > 0 &&
                                <>
                                    <div className="prev-timeline-link">
                                        {isPrevTimelineVisible && <div className="prev-timeline">
                                            <div className="timeline-header">
                                                <div className="time">
                                                    Timeline: {moment(prescriptionDate).format("dd-MM-yyyy")}
                                                </div>
                                                <div className="cross">
                                                    <img
                                                        className="cross"
                                                        src={crossSvg}
                                                        alt="cross"
                                                        onClick={() => setIsPrevTimelineVisible(false)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="timeline-body">
                                                {
                                                    timelineData.map((timeline, count) => {
                                                        if (count > 2) return;
                                                        return (
                                                            <div className="timeline" key={count}>
                                                                <div className="time">
                                                                    {moment(timeline.dateOfCharting).format("HH:mm")}
                                                                </div>
                                                                <div className="body">
                                                                    <div className="user">
                                                                        {`${timeline.userRole}:
                                                                        ${timeline.userName} (${timeline.userId})`}
                                                                    </div>
                                                                    <div className="chart-type">
                                                                        {`Updated the ${timeline.type} in Charting.`}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    })
                                                }
                                            </div>
                                        </div>}
                                        <div
                                            className="link"
                                            onClick={() => setIsPrevTimelineVisible(!isPrevTimelineVisible)}
                                        >Prev. Updated</div>
                                    </div>
                                    <div className="last-timeline">
                                        {`Last Updated by ${timelineData[0].userRole}: 
                                    ${timelineData[0].userName} (${timelineData[0].userId}) at 
                                    ${moment(timelineData[0].dateOfCharting).format("HH:mm")}`}
                                    </div>
                                </>}
                        </div>
                    </div> */}
                    <div className="footer-container">
                        {fetchDataWaitText}
                    </div>
                </div>
            </div >
        </div >

    );
}

const mapStateToProps = (state, ownProps) => {

    let patientSessionId = state.patientDataReducer.patientData
        && state.patientDataReducer.patientData[ownProps.bedId]
        && state.patientDataReducer.patientData[ownProps.bedId].sessionId;
    let hospitalName = state.hospitalDataReducer && state.hospitalDataReducer.hospitalData && state.hospitalDataReducer.hospitalData.hospitalName;
    let selectedWard = state.wardDetailsReducer && state.wardDetailsReducer.selectedWard;
    let patientAdmissionDate = state.patientDataReducer.patientData
        && state.patientDataReducer.patientData[ownProps.bedId]
        && state.patientDataReducer.patientData[ownProps.bedId].admissionDate;
    let patientDischargeDate = state.patientDataReducer.patientData
        && state.patientDataReducer.patientData[ownProps.bedId]
        && state.patientDataReducer.patientData[ownProps.bedId].dischargeDate;
    return {
        patientSessionId: patientSessionId,
        activeSidebarIcon: state.configReducer.config.activeSidebarIcon,
        chartingOptionActive: state.configReducer.config.chartingOptionActive,
        hospitalName: hospitalName,
        selectedWard: selectedWard,
        patientAdmissionDate: patientAdmissionDate,
        patientDischargeDate: patientDischargeDate

    };
};

const mapDispatchToProps = dispatch => {
    return {
        selectedChartingOptionAction: (payload) => dispatch(selectedChartingOptionAction(payload)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ChartContainer);
